import React, { useEffect } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import Helper from '../../utility/helper';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Avatar from '@mui/material/Avatar';
import { useState } from 'react';
import event_ic from '../../assets/Icons/event_ic.svg';
import { useEventState } from '../../stores/eventStore';
import { useHistory, generatePath } from 'react-router-dom';
import RouteConstants from '../../constants/routeConstants';
import ProfileInitial from '../profile/profileInitial';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    TypographyContent: {
        fontSize: '13px'
    },
    Typographyheader: {
        fontSize: '16px',
    },
    buttonContainer: {
        marginTop: theme.spacing(2),
    },
    iconWidth: {
        width: '50px',
        height: '50px',
    },
    picStyle: {
        width: 30,
        height: 30,
        marginRight: '10px',
        fontSize: 12,
    },
}));

const EventCardsDetails = (props) => {
    const classes = useStyles();
    const eventInfo = Helper.getStorage('eventInfo');
    const [keycontactsdata, setkeycontactsdata] = useState([]);
    const [showEventInstruction, setShowEventInstruction] = useState(false);

    const [eventInstruction, setEventInstruction] = useState([]);
    const [modPermission, setModPermission] = React.useState(null);
    const eventState = useEventState();
    const agentInfo = Helper.getStorage('agentUser')
        ? Helper.getStorage('agentUser')
        : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const gAgentInfo = Helper.getSessionStorage('agentUser');
    const agentConnection = Helper.getSessionStorage('agentConnections');
    const history = useHistory();


    const FetchKeycontacts = async () => {
        const eventInfo = Helper.getStorage('eventInfo');

        await ApiHelper.get(APIURLConstants.GET_KEY_CONTACTS(eventInfo.eventID))
            .then((res) => {
                setkeycontactsdata(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getEventInstructions = async () => {
        ApiHelper.get(
            APIURLConstants.GET_PARTICIPANT_INSTRUCTIONS(
                eventInfo.eventID,
                userInfo.userID
            )
        ).then((res) => {
            setShowEventInstruction(res.data.length > 0 ? true : false);
        });
    };
    useEffect(() => {
        if (props.history && props.history.location && props.history.location.state && props.history.location.state.changedUserByAgent) {
            getEventInstructions()
        }
        // console.log('props.history : ', props);
    }, [props]);
    
    useEffect(() => {
        ApiHelper.get(
            APIURLConstants.GET_PARTICIPANT_INSTRUCTIONS_USER(
                eventInfo.eventID,
                userInfo.userID
            )
        )
            .then((res) => {
                if (res.data.length > 0) {
                    // console.log(res.data);
                    setEventInstruction(res.data[0].title);
                }
            })
            .catch((err) => {
                console.log(err);
            });
        FetchKeycontacts();
        getEventInstructions();
    }, []);

    const redirecttoendusereventdetails = () => {
        const path = generatePath(RouteConstants.END_USER_EVENT_INSTRUCTION, {
            eventID: eventInfo.eventID,
        });

        history.push({
            pathname: path,
        });
    };

    // const extractTextFromSpans = (htmlContent) => {
    //     const parser = new DOMParser();
    //     const doc = parser.parseFromString(htmlContent, 'text/html');
    //     const spanElements = doc.querySelectorAll('span');

    //     let extractedText = '';
    //     spanElements.forEach((spanElement, index) => {
    //         extractedText += spanElement.textContent;
    //         if (index < spanElements.length - 1) {
    //             extractedText += ' ';
    //         }
    //     });

    //     return extractedText;
    // };
    const getInitials = (name) => {
        const names = name && name.split(',');
        const firstNameInitial = names && names[0] ? names[0].charAt(0).toUpperCase() : '';
        const lastNameInitial = names && names[1] ? names[1].charAt(0).toUpperCase()  : '';
        return `${firstNameInitial}${lastNameInitial}`.toUpperCase();
        };


    const formatModuleName = (moduleName) => {
            const parts = moduleName.split(/\(([^)]+)\)/);
        
            return (
              <Typography>
                {parts.map((part, index) => (
                  index % 2 === 1 ? (
                    <Typography
                      key={index}
                      component="span"
                      sx={{
                        fontWeight: 400,
                        lineHeight:'31px',
                        fontSize:'13px'
                    }}
                    >
                      ({part})
                    </Typography>
                  ) : (
                    <Typography key={index} component="span"
                    sx={{
                        fontWeight: 400,
                        lineHeight:
                            '31px',
                    }}
                    >
                      {part}
                    </Typography>
                  )
                ))}
              </Typography>
            );
          };
    // console.log("eventInstruction", eventInstruction, showEventInstruction);
    return (
        <Box sx={{ display: 'flex', m: '10px 25px 15px 25px' }}>
            <Box
                flex={showEventInstruction ? 3 : 0}
                sx={{ mr: showEventInstruction ? '40px' : '0px', cursor: 'pointer' }}
                onClick={redirecttoendusereventdetails}>
                {showEventInstruction && (
                    <Paper
                        elevation={3}
                        sx={{
                            p: 2,
                            color: 'white',
                            height: '100%',
                            boxShadow: 'none',
                            borderRadius: 'unset',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            bgcolor: '#394150',
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                width: '100%',
                                gap: '10px',
                            }}>
                            <Box
                                component="img"
                                alt="Eventdetails"
                                src={event_ic}
                                className={classes.iconWidth}></Box>
                            <Box>
                                <Typography
                                    sx={{
                                        color: '#FFFFFF',
                                        lineHeight: '25px',
                                        fontSize: '26px',
                                        fontWeight: 600,
                                    }}
                                    gutterBottom>
                                    Event Allotment
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            onClick={redirecttoendusereventdetails}
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'flex-start',
                                justifyContent: 'flex-start',
                                width: '100%',
                                //boxSizing: 'border-box',
                                height: '100%',
                                overflow: 'hidden',
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    flexWrap: 'wrap',
                                }}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        boxShadow: 'none',
                                        backgroundColor: '#394150',
                                        color: '#7FCDEE',
                                    }}>
                                    <Typography
                                        component="div"
                                        style={{
                                            marginLeft: '1rem',
                                            fontFamily: 'Lato',
                                            marginTop: '10px',
                                            fontSize: '18px',
                                            lineHeight: '19px',
                                        }}>
                                        {eventInstruction && (
                                            <div>{eventInstruction}</div>
                                        )}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'normal',
                                justifyContent: 'space-between',
                                marginTop: '40px',
                                width: '100%',
                            }}>
                            <Box>
                                <Typography
                                    sx={{
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '25px',
                                    }}>
                                    Click here for Event Allotment
                                </Typography>
                            </Box>
                            <Box>
                                <ArrowCircleRightOutlinedIcon
                                    onClick={redirecttoendusereventdetails}
                                    style={{
                                        cursor: 'pointer',
                                        width: '28px',
                                        height: '28px',
                                    }}
                                />
                            </Box>
                        </Box>
                    </Paper>
                )}
            </Box>
            <Box flex={showEventInstruction ? 8 : 11}>
                {keycontactsdata.keyContactPersons &&
                keycontactsdata.keyContactPersons.length > 0 ? (
                    <Paper
                        elevation={3}
                        sx={{
                            p: 2,
                            bgcolor: '#DDE5F9',
                            color: 'white',
                            height: '100%',
                            boxShadow: 'none',
                            borderRadius: 'unset',
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                color: 'black',
                                justifyContent: 'flex-start',
                            }}>
                            <Typography
                                variant="h6"
                                gutterBottom
                                sx={{
                                    display: 'flex',
                                    color: 'black',
                                    fontWeight: 700,
                                    lineHeight: '25px',
                                }}
                                className={classes.Typographyheader}>
                                Event Key Contacts
                            </Typography>
                        </Box>
                        {keycontactsdata &&
                            keycontactsdata.keyContact &&
                            keycontactsdata.keyContact.map((item) => (
                                <Box>
                                    {keycontactsdata.keyContactPersons &&
                                        keycontactsdata.keyContactPersons.map(
                                            (item) => (
                                                <Box key={item.keyContactID}>
                                                    {item.keyContactPersonDetails &&
                                                        item.keyContactPersonDetails.map(
                                                            (person, index) => (
                                                                <Box
                                                                    key={
                                                                        person.keyContactPersonID
                                                                    }
                                                                    sx={{
                                                                        display:
                                                                            'flex',
                                                                        flexDirection:
                                                                            'row',
                                                                        width: '100%',
                                                                        alignItems:
                                                                            'center',
                                                                        justifyContent:
                                                                            'flex-start',
                                                                        p: '5px',
                                                                    }}>
                                                                    {index ===
                                                                    0 ? (
                                                                        <Box
                                                                            sx={{
                                                                                width: '30%',
                                                                                color: '#17408B',
                                                                            }}>
                                                                            <Typography
                                                                                className={
                                                                                    classes.TypographyContent
                                                                                }
                                                                                sx={{
                                                                                    fontSize:
                                                                                        '13px',
                                                                                    lineHeight:
                                                                                        '31px',
                                                                                    fontWeight: 700,
                                                                                }}>
                                                                                {/* {formatModuleName(
                                                                                    person.moduleName
                                                                                        .charAt(
                                                                                            0
                                                                                        )
                                                                                        .toUpperCase() +
                                                                                        person.moduleName
                                                                                            .slice(
                                                                                                1
                                                                                            )
                                                                                            .toLowerCase()
                                                                                )} */}
                                                                                {formatModuleName(person.moduleName)}
                                                                            </Typography>
                                                                        </Box>
                                                                    ) : (
                                                                        <Box
                                                                            sx={{
                                                                                width: '30%',
                                                                                color: '#17408B',
                                                                            }}>
                                                                            &nbsp;{' '}
                                                                        </Box>
                                                                    )}
                                                                    <Box
                                                                        sx={{
                                                                            display:
                                                                                'flex',
                                                                            flexDirection:
                                                                                'row',
                                                                            alignItems:
                                                                                'center',
                                                                            justifyContent:
                                                                                'flex-start',
                                                                            width: '70%',
                                                                            color: 'black',
                                                                            flexWrap:
                                                                                'warp',
                                                                        }}>
                                                                        <Box
                                                                            sx={{
                                                                                mr: '10px',
                                                                            }}>
                                                                            {/* <ProfileInitial
                                                                                data={{
                                                                                    name: person.participant,
                                                                                    picUrl: person.ProfilePicUrl,
                                                                                    profilePicUrl:
                                                                                        person.ProfilePicUrl,
                                                                                    email: person.isEmail
                                                                                        ? person.email
                                                                                        : '',
                                                                                }}
                                                                                navigationScreen={
                                                                                    ''
                                                                                }
                                                                                showOnlyInitial={
                                                                                    true
                                                                                }
                                                                                size={
                                                                                    25
                                                                                }
                                                                            /> */}
                                                                            <Avatar
                                                                                className={
                                                                                    classes.picStyle
                                                                                }
                                                                                src={
                                                                                    person.profilePicUrl
                                                                                        ? person.profilePicUrl
                                                                                        : null
                                                                                }
                                                                                sx={{
                                                                                    backgroundColor:
                                                                                        'primary.main',
                                                                                }}
                                                                                alt={getInitials(
                                                                                    person.avatarName
                                                                                )}>
                                                                                {person.profilePicUrl
                                                                                    ? null
                                                                                    : getInitials(
                                                                                          person.avatarName
                                                                                      )}
                                                                            </Avatar>
                                                                        </Box>
                                                                        <Box>
                                                                            <Typography
                                                                                className={
                                                                                    classes.TypographyContent
                                                                                }
                                                                                sx={{}}>
                                                                                {
                                                                                    <>
                                                                                        <span
                                                                                            style={{
                                                                                                fontWeight: 600,
                                                                                                lineHeight:
                                                                                                    '31px',
                                                                                            }}>
                                                                                            {
                                                                                                person.participant
                                                                                            }
                                                                                        </span>
                                                                                        {item.isEmail &&
                                                                                            person.email && (
                                                                                                <span
                                                                                                    style={{
                                                                                                        fontWeight: 400,
                                                                                                        lineHeight:
                                                                                                            '31px',
                                                                                                    }}>
                                                                                                    &nbsp;(
                                                                                                    {
                                                                                                        person.email
                                                                                                    }

                                                                                                    )
                                                                                                </span>
                                                                                            )}
                                                                                        {item.isContact &&
                                                                                            person.contactNo &&
                                                                                            person.contactNo !==
                                                                                                '' &&
                                                                                            person.contactNo !==
                                                                                                '0' &&
                                                                                            person.contactNo !==
                                                                                                null && (
                                                                                                <span
                                                                                                    style={{
                                                                                                        fontWeight: 400,
                                                                                                        lineHeight:
                                                                                                            '31px',
                                                                                                    }}>
                                                                                                    &nbsp;+1
                                                                                                    {person.contactNo.replace(
                                                                                                        /(\d{3})(\d{3})(\d{4})/,
                                                                                                        ' $1 $2 $3'
                                                                                                    )}
                                                                                                </span>
                                                                                            )}
                                                                                    </>
                                                                                }
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                            )
                                                        )}
                                                </Box>
                                            )
                                        )}
                                </Box>
                            ))}
                    </Paper>
                ) : null}
            </Box>
        </Box>
    );
};

export default  React.memo(EventCardsDetails);
